import React, { Component, type ComponentType } from 'react';
import noop from 'lodash/noop';
import { ComponentWithAnalytics } from '@atlassian/jira-analytics-web-react/src';
import type { ExpandedItems } from '../../../../../model/table';
import type { TimelineDuration, TimelineMode } from '../../../../../model/timeline';
import { FlatItems, type ItemMeta } from '../../../common/components/flat-items';
import type { TableCommonProps, ChartItem, ChartChildItem } from '../../../common/types';
import { getPositionFromDateFn } from '../../../common/utils';
import type { APIProps as BarProps } from '../../bar';
import type { APIProps as ChartItemProps } from '../../chart-item';

type Components = {
	ChartItem: ComponentType<ChartItemProps>;
	Bar: ComponentType<BarProps>;
};

type APIProps = {
	items: ChartItem[];
} & TableCommonProps & {
		expandedItems: ExpandedItems;
		timelineDuration: TimelineDuration;
		timelineMode: TimelineMode;
		// go/jfe-eslint
		timelineDefaultPosition: number;
		components: Components;
		// go/jfe-eslint
		listWidth: number;
	};

type Props = APIProps;

// eslint-disable-next-line jira/react/no-class-components
class RoadmapChartItems extends Component<Props> {
	static defaultProps = {
		items: [],
		expandedItems: {},
		onItemClick: noop,
	};

	renderItem = (item: ChartItem | ChartChildItem, { parentId }: ItemMeta) => {
		const {
			timelineMode,
			timelineDuration,
			components,
			isSelectEnabled,
			isHoverEnabled,
			onItemClick,
			itemHeight,
		} = this.props;

		const { id, level } = item;
		const getPositionFromDate = getPositionFromDateFn(
			timelineDuration.startDate,
			timelineDuration.endDate,
			timelineMode,
		);

		return (
			<components.ChartItem
				key={id}
				id={id}
				parentId={parentId}
				level={level}
				timelineMode={timelineMode}
				timelineDuration={timelineDuration}
				itemHeight={itemHeight}
				isSelectEnabled={isSelectEnabled}
				isHoverEnabled={isHoverEnabled}
				getPositionFromDate={getPositionFromDate}
				onClick={onItemClick}
				Bar={components.Bar}
			/>
		);
	};

	render() {
		const { items, expandedItems, activeLevel } = this.props;

		return (
			<FlatItems
				items={items}
				expandedItems={expandedItems}
				activeLevel={activeLevel}
				renderItem={this.renderItem}
			/>
		);
	}
}

export default ComponentWithAnalytics('bar', {
	onItemClick: 'clicked',
})(RoadmapChartItems);

export type { APIProps };
